export abstract class SkillFormData {
  protected constructor() {}
}

export class ProductDescriptionSkillFormData extends SkillFormData {
  constructor(
    public productName: string,
    public productType: string,
    public productCharacteristic: string,
    public productAudience?: string
  ) {
    super()
  }
}

export class SingleSkillFormData extends SkillFormData {
  constructor(public input: string) {
    super()
  }
}

export class MetaTagsSkillFormData extends SkillFormData {
  constructor(
    public websiteName: string,
    public productOrServiceName: string,
    public productOrServiceType: string,
    public productOrServiceCharacteristic: string
  ) {
    super()
  }
}
